'use client';

import { usePathname } from 'next/navigation';
import { getServerSideURL } from '@/utilities/getURL';

export function Canonical() {
  const pathname = usePathname();
  const cleanUrl = `${getServerSideURL()}${pathname}`;

  return <link rel="canonical" href={cleanUrl} />;
}
